import {get} from "../util/http.service"

export const apiGetContext = () => ({
  queryKey: ["context"],
  queryFn: () => get("/api/app/context"),
  staleTime: Infinity,
  gcTime: Infinity,
});
